<section class="ecb-x-admin-list-section">

  <div class="container-fluid">

    <div class="ecb-x-admin-list-card">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 class="ecb-section-title">Customers</h1>
          <p class="ecb-muted mb-0">View registered customers and add manual customers.</p>
        </div>
        <button class="ecb-btn-primary" (click)="openNew()">Add New</button>
      </div>
      <p-table [value]="pagedCustomers" responsiveLayout="scroll" styleClass="ecb-admin-table">

        <!-- Header -->
        <ng-template pTemplate="header">

          <tr class="ecb-admin-table-header-row">

            <th class="ecb-admin-table-header">
              ID
            </th>

            <th class="ecb-admin-table-header">
              First Name
            </th>

            <th class="ecb-admin-table-header">
              Last Name
            </th>

            <th class="ecb-admin-table-header">
              Email
            </th>

            <th class="ecb-admin-table-header">
              Mobile
            </th>

            <th class="ecb-admin-table-header ecb-admin-table-action-header">
              Action
            </th>

          </tr>

        </ng-template>


        <!-- Body -->
        <ng-template pTemplate="body" let-row>

          <tr class="ecb-admin-table-row">

            <!-- ID -->
            <td class="ecb-admin-table-cell">
              {{ row.userId }}
            </td>

            <!-- First Name -->
            <td class="ecb-admin-table-cell">
              {{ row.firstName }}
            </td>

            <!-- Last Name -->
            <td class="ecb-admin-table-cell">
              {{ row.lastName }}
            </td>

            <!-- Email -->
            <td class="ecb-admin-table-cell">
              {{ row.email }}
            </td>

            <!-- Mobile -->
            <td class="ecb-admin-table-cell">
              {{ row.mobileNo || '-' }}
            </td>

            <!-- Action -->
            <td class="ecb-admin-table-cell ecb-admin-table-action-cell">

              <button type="button" class="ecb-admin-table-action-button ecb-admin-table-edit-button"
                (click)="edit(row)" title="Edit user" [attr.aria-label]="'Edit ' + row.firstName + ' ' + row.lastName">

               <i class="bi bi-pencil-square ecb-admin-table-action-icon"></i>

              </button>

            </td>

          </tr>

        </ng-template>


        <!-- Empty -->
        <ng-template pTemplate="emptymessage">

          <tr class="ecb-admin-table-row">

            <td colspan="6" class="ecb-admin-table-cell text-center py-4">

              No records found.

            </td>

          </tr>

        </ng-template>

      </p-table>

      <!-- Start Customers Table Footer -->
      <div class="ecb-x-admin-customers-table-footer">

        <div class="row align-items-center gy-3">

          <!-- Showing Records -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-customers-paginator-info">

              Showing
              {{ startRecord }}–{{ endRecord }}
              of {{ rows.length }} customers

            </div>

          </div>


          <!-- Rows Per Page -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-customers-paginator-size">

              <label for="customersPageSize">
                Rows per page
              </label>

              <select id="customersPageSize" class="form-select form-select-sm" [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeChange()">

                <option [ngValue]="10">10</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>

              </select>

            </div>

          </div>


          <!-- Page Navigation -->
          <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-customers-paginator-navigation">

              <!-- Previous -->
              <button type="button" class="ecb-x-admin-customers-page-button" [disabled]="currentPage === 1"
                (click)="previousPage()">

                Previous

              </button>


              <!-- Page Numbers -->
              <button type="button" *ngFor="let page of pageNumbers" class="ecb-x-admin-customers-page-button"
                [class.ecb-x-admin-customers-page-active]="currentPage === page"
                [attr.aria-current]="currentPage === page ? 'page' : null" (click)="changePage(page)">

                {{ page }}

              </button>


              <!-- Next -->
              <button type="button" class="ecb-x-admin-customers-page-button" [disabled]="currentPage === totalPages"
                (click)="nextPage()">

                Next

              </button>

            </div>

          </div>

        </div>

      </div>
      <!-- End Customers Table Footer -->

      <p-dialog [(visible)]="showDialog" [modal]="true" [style]="{width:'560px'}" header="Customers">
        <div class="row g-3">
          <div class="col-md-6" *ngFor="let field of editorFields">
            <label>{{ field.label }}</label>
            <input class="ecb-form-control" [(ngModel)]="editor[field.name]"
              [disabled]="(field.name === 'userId' || field.name === 'email')?true:false">
          </div>
        </div>
        <ng-template pTemplate="footer"><button class="ecb-btn-outline"
            (click)="showDialog=false">Cancel</button><button class="ecb-btn-primary"
            (click)="save()">Save</button></ng-template>
      </p-dialog>

    </div>
  </div>
</section>